import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToasterALV1Component } from './toaster-al-v1/toaster-al-v1.component';
import { ToasterALV1Service } from './toaster-al-v1/toaster-al-v1.service';


@NgModule({
  declarations: [
    ToasterALV1Component
  ],
  exports: [
    ToasterALV1Component
  ],
  imports: [
    CommonModule
  ],
  providers: [
    ToasterALV1Service
  ]
})
export class ToasterModule { }
